
import { combineReducers } from 'redux';
import accountReducer from './accountReducer';
import authenticationReducer from './authenticationReducers'
import membershipReducer from './membershipReducer'
import waiverReducer from './waiverReducer';

const rootReducer = combineReducers({
    authentication: authenticationReducer,
    account: accountReducer,
    memberships: membershipReducer,
    waiver: waiverReducer
});

export default rootReducer